var map = {
	"./": 38010,
	"./Component": 96977,
	"./Component.tsx": 96977,
	"./class1.svg": 36361,
	"./class2.svg": 28935,
	"./class3.svg": 2746,
	"./class4.svg": 17452,
	"./class5.svg": 88274,
	"./class6.svg": 76608,
	"./class7.svg": 73687,
	"./class8.svg": 79852,
	"./index": 38010,
	"./index.ts": 38010,
	"./vendorCard.css": 26507,
	"./vendorcard.test": 55150,
	"./vendorcard.test.tsx": 55150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15251;